const DEFAULT_CREDIT_API_ROOT = "https://auto.perxis.pt.perx.ru/credit/api/v1";
export {
  DEFAULT_CREDIT_API_ROOT
};
